import React, {useState, useEffect} from "react";
import { IExtendedL3 } from "../../services/NetworkApi";
import { Table } from "../../UI/Table";
import { TableHeader } from "../TableHeader";
import { Typography } from "../../UI/Typography";
import { COLOR_WHITE } from "../../constants/styles";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { TableCell } from "../../UI/TableCell";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { StatusSwitch } from "./StatusSwitch";
import { SetAllToButtons } from "./SetAllToButtons";
import { TablePagination } from "../TablePagination";
import { useTablePaginationContext } from "../TablePagination/context";
import { usePaginationHandler } from "../../hooks/usePaginationHandler";
import { useMatchingRulesHandler } from "../../hooks/useMatchingRulesHandler";

interface IProps {
}

export const PauseUnitTypeMatchingTable: React.FC<IProps> = (props) => {
  const { data, isLoading, setData, getData } = useMatchingRulesHandler();
  const { page, setPage, perPage, setPages } = useTablePaginationContext();
  const [subnetwork, setSubnetwork] = React.useState<number>(0);
  const [ filteredData, setFilteredData ] = useState<IExtendedL3[]>([]);
  const [ showArchived, setShowArchived ] = useState<boolean>(false);

  const { selectedRows, pages } = usePaginationHandler(
    filteredData,
    page,
    perPage
  );
  
  useEffect(() => {
    const newData = data
      .filter(row => showArchived? row : row.matchingRoundStatus!== "ARCHIVED")
      .filter(row => subnetwork === 0 || !subnetwork ? row: row.l2Id === subnetwork);
    setFilteredData(newData);

  }, [showArchived, subnetwork, data]);

  const handleToggleArchiveChange = (_: any, checked: boolean) =>setShowArchived(checked);

  const isReadOnly = (row: any) => (row?.matchingRoundStatus === "ARCHIVED" || row?.matchingRoundStatus === "CLOSED");

  React.useEffect(() => {
    setPages(pages);
    setPage(1);
  }, [pages.length]);

  return (
    <>
      <TableHeader
        py={5}
        endAdornment={
          <SetAllToButtons
            unitTypes={data}
            updateData={setData}
            getData={getData}
            showArchived={showArchived}
            subnetwork={subnetwork}
            setSubnetwork={setSubnetwork}
            changeArchivedVisiblity={handleToggleArchiveChange}
          />
        }
      >
        <Typography fontWeight={600} color={COLOR_WHITE}>
          Pause Unit Type Matching
        </Typography>
      </TableHeader>
      <Table>
        <TableHead secondary>
          <TableRow>
            <TableCell>Matching Round </TableCell>
            <TableCell>
                
            </TableCell>
          </TableRow>
        </TableHead>
        <EnhancedTableBody colSpan={3} isLoading={isLoading}>
          {selectedRows.map((row) => (
            <TableRow key={row.key}>
              <TableCell width="50%">
                {row.l2name} | {row.name}
              </TableCell>
              <TableCell>
                <StatusSwitch
                  l2Id={row.l2Id}
                  l3Id={row.l3Id}
                  updateData={setData}
                  defaultValue={row.forcedClosed}
                  isDisabled={isReadOnly(row)}
                />
              </TableCell>
            </TableRow>
          ))}
        </EnhancedTableBody>
      </Table>
      <TablePagination />
    </>
  );
};
